import { Config } from '@flowwai-frontend/shared/constants'

export const isPinnedBoardsEnabled = Config.ENABLE_PINNED_BOARDS === 'true'
